export const calculateCentroid = (
  coordinates: number[][]
): [number, number] => {
  let area = 0.0
  let x = 0.0
  let y = 0.0
  const n = coordinates.length

  for (let i = 0; i < n - 1; i++) {
    const x0 = coordinates[i][0]
    const y0 = coordinates[i][1]
    const x1 = coordinates[i + 1][0]
    const y1 = coordinates[i + 1][1]

    const a = x0 * y1 - x1 * y0
    area += a
    x += (x0 + x1) * a
    y += (y0 + y1) * a
  }

  if (area === 0) {
    // For degenerate polygons, fall back to simple average
    coordinates.forEach(coord => {
      x += coord[0]
      y += coord[1]
    })
    return [y / n, x / n]
  }

  area *= 3
  return [y / area, x / area]
}
